import { BorderRadius, FontSize, LineHeight, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import EInvoicesEmptyDashboardBanner from '../../../../assets/images/e-invoicing/dashboard-banner-e-invoices-empty.svg'

export const CegidEInvoicesWidgetWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: ${Spacing.S24};
  border-radius: ${BorderRadius.R12};
  position: absolute;
  top: 0;
  left: 0;
  background-image: url(${EInvoicesEmptyDashboardBanner});
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: 50%;
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-left: ${Spacing.S8};
`
export const Header = styled.div``

export const DescriptionWrapper = styled.div`
  width: 60%;
  font-size: ${FontSize.TextBodyLG};
  line-height: ${LineHeight.TextBodyLG};
`
